import { FilterContext } from "../../../interfaces/api/filter";
import client from "../client";
import { generateFilterQuery } from "../helpers";

export function getSchools(filterContext: FilterContext = []) {
  const query = encodeURI(generateFilterQuery(filterContext));
  return client.get(`/api/v2/schools${query}`);
}
